import {register} from '../../../../assets/js/modules/eventMap';

const scrollToBottom = (el) => {
    el.scrollTop = el.scrollHeight;
};

// Debounce helper to wait for rendering to settle
const debounce = (fn, delay = 100) => {
    let timeout;

    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
    };
};

const scrollToBottomOnLoad = (el) => {
    const lastMarkedMessage = el.querySelector('[data-marked]:last-child');

    if (!lastMarkedMessage) {
        scrollToBottom(el);

        return;
    }

    // Watch for both attribute changes and subtree modifications
    const observer = new MutationObserver(
        debounce(() => {
            if (lastMarkedMessage.dataset.markedProcessed === 'true') {
                scrollToBottom(el);
                observer.disconnect();
            }
        })
    );

    observer.observe(lastMarkedMessage, {
        attributes: true,
        attributeFilter: ['data-marked-processed'],
        subtree: true,
        childList: true // Watch for Prism modifications
    });

    // Initial check in case already processed
    if (lastMarkedMessage.dataset.markedProcessed === 'true') {
        scrollToBottom(el);
    }
};

const chatLog = () => {
    register('chatLog', {scrollToBottomOnLoad});
};

export {chatLog, scrollToBottom};
